// El botón de acción de la edición en el visor, con el estilo del "Generar" de Redes:
// degradé azul que se funde al apagarse, sombra azul, sube 2 px al pasar el mouse y el
// costo en su pastilla blanca con el ícono de créditos de toda la app
// (ADR-2026-10-06-editar-en-el-visor-2). Sin `creditos`, sin pastilla (el recorte es gratis).

import { Check, Loader2 } from 'lucide-react';
import type { ReactNode } from 'react';

export function BotonConCreditos({
  children,
  creditos,
  ocupado = false,
  listo = false,
  disabled = false,
  type = 'button',
  onClick,
  className = '',
}: {
  children: ReactNode;
  creditos?: number;
  ocupado?: boolean;
  /** Recién terminó: un check breve antes del texto. */
  listo?: boolean;
  disabled?: boolean;
  type?: 'button' | 'submit';
  onClick?: () => void;
  className?: string;
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || ocupado}
      className={`group relative inline-flex h-10 shrink-0 items-center justify-center gap-2 overflow-hidden rounded-full bg-white/15 py-2 text-[14px] font-semibold text-white shadow-[0_10px_24px_-10px_rgba(22,68,235,0.65)] transition-[transform,box-shadow] duration-300 ease-out hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:shadow-none disabled:hover:translate-y-0 ${
        creditos !== undefined ? 'pl-4 pr-1.5' : 'px-5'
      } ${className}`}
    >
      <span
        aria-hidden="true"
        className="absolute inset-0 bg-[linear-gradient(181.87deg,#2563F5_8.76%,#0436AE_90.56%)] opacity-100 transition-opacity duration-300 ease-out group-disabled:opacity-0"
      />
      <span className="relative inline-flex items-center gap-1.5">
        {ocupado ? (
          <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
        ) : listo ? (
          <Check className="h-4 w-4 animate-fade-in" aria-hidden="true" />
        ) : null}
        {children}
      </span>
      {creditos !== undefined && (
        <span className="relative inline-flex items-center gap-1 rounded-full bg-white px-2 py-0.5 text-[12.5px] font-semibold tabular-nums text-brand-black transition-opacity duration-300 ease-out group-disabled:opacity-50">
          <img src="/images/token_icon.png" alt="" aria-hidden="true" className="h-3.5 w-3.5 object-contain" />
          {creditos}
        </span>
      )}
    </button>
  );
}

export default BotonConCreditos;
